var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "subTab": "",
      "sh": "About us",
      "index": "01",
      "total": "04",
      "tabActive": "Company Profile",
      "bg": "/images/sub/visual/sv1.jpg"
    }
  }), _c('section', {
    staticClass: "section section--first pb-0"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h2', {
    staticClass: "tit tit--lg dot-tit"
  }, [_vm._v("Company Profile")])])]), _c('div', {
    staticClass: "cover-bg py-40 py-md-60 py-lg-90",
    staticStyle: {
      "background-image": "url(/images/sub/aboutus/company-profile-bg.jpg)"
    }
  }, [_c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "4",
      "order-md": "2",
      "offset-lg": "1"
    }
  }, [_c('div', {
    staticClass: "mb-20"
  }, [_c('v-img', {
    staticClass: "mx-auto mt-lg-n180",
    attrs: {
      "max-width": "464",
      "aspect-ratio": 464 / 250,
      "src": "/images/sub/aboutus/company-profile-logo.jpg"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "7",
      "order-md": "1"
    }
  }, [_c('div', {
    staticClass: "page-text white--text"
  }, [_c('p', [_vm._v("KIE (Korea Instrument and Electric) Systems brings rich experience and unique solution together in the engineering and integration such as analytical instruments.")]), _c('p', [_vm._v(" This enables the company to meet the ever-increasing requirements of range of applications in the process industries carrying potentially hazardous chemicals and gases. ")]), _c('p', [_vm._v(" The KIE Systems has held ISO9001 since 2003 and has successfully implemented a Total Quality program providing continuous improvements that offer significant benefits to the customer. This has built product confidence and a reputation of quality and reliability. ")])])])], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit top-line-tit"
  }, [_vm._v("Industries include")])]), _c('v-item-group', {
    attrs: {
      "mandatory": ""
    }
  }, [_c('v-row', _vm._l(_vm.items, function (item, i) {
    return _c('v-item', {
      key: i,
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(_ref) {
          var active = _ref.active,
              toggle = _ref.toggle;
          return [_c('v-col', {
            staticClass: "transition",
            attrs: {
              "cols": "12",
              "md": active ? '6' : '2'
            }
          }, [_c('v-card', {
            staticClass: "cursor-pointer",
            attrs: {
              "tile": "",
              "elevation": "0"
            },
            on: {
              "mouseenter": toggle
            }
          }, [_c('v-img', {
            staticClass: "w-100 h-200px h-md-500px",
            staticStyle: {
              "position": "relative"
            },
            attrs: {
              "cover": "",
              "src": active ? item.srcOn : item.src
            }
          }, [_c('div', {
            staticClass: "w-100 h-100",
            class: active ? 'd-flex' : ''
          }, [_c('v-overlay', {
            staticClass: "mt-auto pa-20 px-md-60 py-md-32 h-100",
            class: active ? 'h-100px justify-start' : '',
            attrs: {
              "absolute": "",
              "opacity": "0.4",
              "color": "#000"
            }
          }, [_c('div', {
            class: active ? 'font-size-20 font-size-md-26' : 'font-size-16 font-size-md-18 text-center'
          }, [_c('div', {
            class: {
              'd-inline-block': active
            }
          }, [_vm._v(_vm._s(item.num))]), _c('div', {
            staticClass: "font-weight-bold",
            class: {
              'd-inline-block pl-6 pl-md-10': active
            }
          }, [_vm._v(_vm._s(item.title))])])])], 1)])], 1)], 1)];
        }
      }], null, true)
    });
  }), 1)], 1)], 1)], 1), _c('section', {
    staticClass: "section grey-f7"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h3', {
    staticClass: "tit top-line-tit"
  }, [_vm._v("Core competencies")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('p', {
    staticClass: "page-text pt-lg-18"
  }, [_vm._v(" The company’s core competencies lie in the design, engineering, development of diverse kinds of analyzer systems. Placing the company at the forefront of innovation with a high commitment to research and engineering the company offers solutions to wide range of instrumentation and analyzer system. ")])])], 1)], 1)])], 1), _c('section', {
    staticClass: "section section--last pt-0 mt-n80 mt-md-n120 mt-lg-n160"
  }, [_c('v-container', [_c('div', {
    staticClass: "core-competencies-slide"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    staticStyle: {
      "potision": "relative"
    },
    attrs: {
      "tile": "",
      "color": "white",
      "elevation": "0",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "card-num"
  }, [_vm._v("01")]), _c('div', {
    staticClass: "px-20 py-30 px-md-30 pb-md-40 px-lg-60 pb-lg-80 px-xl-120 pt-xl-90"
  }, [_c('div', {
    staticClass: "mb-16 mb-md-24"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v("How we work")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('p', [_vm._v(" With these markets continuously changing, The KIE Systems fully appreciates the need for organizations to maintain a flexible business approach. A global presence with an understanding of individual local needs has enabled the company to retain its competitive edge. ")]), _c('p', [_vm._v(" As a further extension to its manufacturing capabilities, the company offers project management for specialized process analyzer systems, service centers and 24 hour on-line technical support. ")])])])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/aboutus/company-profile-slide.jpg"
    }
  })])], 1)], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    staticStyle: {
      "potision": "relative"
    },
    attrs: {
      "tile": "",
      "color": "white",
      "elevation": "0",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "card-num"
  }, [_vm._v("02")]), _c('div', {
    staticClass: "px-20 py-30 px-md-30 pb-md-40 px-lg-60 pb-lg-80 px-xl-120 pt-xl-90"
  }, [_c('div', {
    staticClass: "mb-16 mb-md-24"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v("Engineering Capacity")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('p', [_vm._v(" We have 25+ senior engineers in the analyzer team, and all of us are fluent in English conversation. Manufacturing, technology, and service experts are in your business. Our company is interested in QA/QC, and we are deploying personnel in the right place. ")])])])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/aboutus/company-profile-slide2.jpg"
    }
  })])], 1)], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    staticStyle: {
      "potision": "relative"
    },
    attrs: {
      "tile": "",
      "color": "white",
      "elevation": "0",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "card-num"
  }, [_vm._v("03")]), _c('div', {
    staticClass: "px-20 py-30 px-md-30 pb-md-40 px-lg-60 pb-lg-80 px-xl-120 pt-xl-90"
  }, [_c('div', [_c('div', {
    staticClass: "mb-16 mb-md-24"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v("Production capacity")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', {
    attrs: {
      "cols": ""
    }
  }, [_vm._v(" As yearly basis, we can the analyzer package system around "), _c('b', [_vm._v("100 packages")])])], 1), _c('v-row', {
    staticClass: "row--small mt-6"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', {
    attrs: {
      "cols": ""
    }
  }, [_vm._v(" The shelter size will be around 5mW *3mD * 2.7mH ")])], 1)], 1)]), _c('div', {
    staticClass: "mt-30 mt-md-46"
  }, [_c('div', {
    staticClass: "mb-16 mb-md-24"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v("Factory Facilities")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', {
    attrs: {
      "cols": ""
    }
  }, [_vm._v(" Fabrication size : 31mW * 32.5mD (10007.5 sq.m) ")])], 1), _c('v-row', {
    staticClass: "row--small mt-6"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', {
    attrs: {
      "cols": ""
    }
  }, [_vm._v(" Inspection size : 15mW * 32.5mD (487.5 sq.m) ")])], 1), _c('v-row', {
    staticClass: "row--small mt-6"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', {
    staticStyle: {
      "letter-spacing": "-.03em !important"
    },
    attrs: {
      "cols": ""
    }
  }, [_vm._v(" Conference room / Warehouse / Office / All tool sets ")])], 1)], 1)])])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/aboutus/company-profile-slide3.jpg"
    }
  })])], 1)], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    staticStyle: {
      "potision": "relative"
    },
    attrs: {
      "tile": "",
      "color": "white",
      "elevation": "0",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "card-num"
  }, [_vm._v("04")]), _c('div', {
    staticClass: "px-20 py-30 px-md-30 pb-md-40 px-lg-60 pb-lg-80 px-xl-120 pt-xl-90"
  }, [_c('div', {
    staticClass: "mb-16 mb-md-24"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v("After service")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('p', [_vm._v(" Even after the project is completed, KIE SYSTEM’s after service will continue. We support site commissioning, Site Acceptance Test (SAT), troubleshooting and so on. ")])])])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/aboutus/company-profile-slide4.jpg"
    }
  })])], 1)], 1)]), _c('div', {
    staticClass: "swiper-control"
  }, [_c('v-btn', {
    staticClass: "swiper-prev border-1 mr-6 mr-lg-10",
    attrs: {
      "icon": "",
      "outlined": "",
      "large": "",
      "color": "grey-d"
    }
  }, [_c('i', {
    staticClass: "icon icon-left-arrow-grey"
  })]), _c('v-btn', {
    staticClass: "swiper-next border-1",
    attrs: {
      "icon": "",
      "outlined": "",
      "large": "",
      "color": "grey-d"
    }
  }, [_c('i', {
    staticClass: "icon icon-right-arrow-grey"
  })])], 1)])])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }